export default __webpack_public_path__ + "src/assets/inbound.bd8c50e55eec2a8359b2c5b7ddf65fce.svg";